import axios from '@/common/axios'

export function fetchGalleryImages(params, config = {}) {
  return axios.get('/api/images', { params, ...config })
}

export function uploadImage(formData, config = {}) {
  return axios.post('/api/images', formData, config)
}

export function bulkDeleteImages(ids) {
  return axios.delete('/api/images/bulk_delete', { params: { ids } })
}

export function updateImageTags(data) {
  return axios.post('/api/images/update_tags', data)
}

export function fetchImageExifs(imageId) {
  return axios.get(`/api/images/${imageId}/exifs`)
}

export function extractFileExifs(formData) {
  return axios.post('/api/gmb/media/extract_exifs', formData)
}

export function previewExif(params) {
  return axios.post('/api/gmb/preview/exif', params)
}

export function fetchExifTemplates() {
  return axios.get('/api/exif_templates/index_for_select', { params: { with_exifs: true } })
}
